module.exports = __webpack_public_path__ + "img/night_shelter.161845a6.svg";